// @flow

import { env } from "@cabonline/shared/utils/env"

const bookingClientUrl = `https://${env}bc.cabonline.com`
console.log(`BC URL set to ${bookingClientUrl}`)

const isLocalHost = () => {
  if (typeof window === "undefined") return false

  const hostname = window.location.hostname.toLowerCase()
  if (hostname === "localhost" || hostname === "127.0.0.1") return true
  if (hostname === "[::1]" || hostname.endsWith(".local")) return true

  return false
}
console.log(`BC isLocalHost: ${isLocalHost()}`)

export default {
  id: "bc",
  intlBase: "externalApps.bc",
  url: bookingClientUrl,
  localUrl: isLocalHost() ? "http://localhost:1337" : bookingClientUrl
}
